import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { AdrCodesClient } from "@/features/orders/AdrCodesClient";
import { adrCodeKeys, listAdrCodes } from "@/features/orders/orders.api";
import { firstAllowedRoute } from "@/lib/auth";

// Beheer → ADR-codes: the list order entry picks a consignment's ADR code from (20-10-2026). Setting things up, so
// admins only — as with the other lists under Beheer; order entry reads it in the field ADR-code.

export const Route = createFileRoute("/_shell/adr-codes")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: AdrCodesScreen,
});

function AdrCodesScreen() {
  const { session } = Route.useRouteContext();
  const list = useQuery({ queryKey: adrCodeKeys.list("all"), queryFn: () => listAdrCodes("all") });
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office ADR Codes">
      <AdrCodesClient initialItems={list.data ?? []} userId={session.userId} isFetching={list.isFetching} isLoading={list.isLoading} />
    </div>
  );
}
